import React from 'react';
import { translate } from 'react-i18next';
import { Platform, StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import { connect } from 'react-redux';
import { CardioOrResistance } from 'fitbeat.models';
import BuildIcon from '../../assets/icons/activity-types/functional-strength-outlined.svg'
import BurnIcon from '../../assets/icons/activity-types/functional-cardio-outlined.svg'
import BalanceIcon from '../../assets/icons/activity-types/functional-pilates-outlined.svg'
import Theme from '../../theme';
import { SkeletonLoader } from '../../ui/components/SkeletonLoader.native';
import { defaultScale, scaledRatio } from '../../utils/scaling';
import { NoHeartRateMonitorImageTile } from './NoHeartRateMonitorImageTile';
import { TileHeader } from './TileHeader';

const LastWorkoutTileComponent = ({
  userProfile,
  t,
  weeklyWorkoutStatsIsLoading,
  weeklyWorkoutStats,
  hasLastWorkout,
  lastWorkoutHasMetrics,
  navigation,
}) => {
  const hasHeartRateMonitor = userProfile && !!userProfile.heartRateMonitorIdentifier;
  if (weeklyWorkoutStatsIsLoading) {
    return <View style={styles.mainTileContainer}>
      <SkeletonLoader containerStyle={{ height: defaultScale(300) }} />
    </View>;
  }

  if (!hasHeartRateMonitor && !hasLastWorkout) {
    return <View style={styles.mainTileContainer}>
      <NoHeartRateMonitorImageTile containerStyle={{ marginTop: 0 }} />
    </View>;
  }

  if (hasHeartRateMonitor && !hasLastWorkout) {
    // Make no sense to show anything when hr monitor connected but no prior workouts
    return <></>;
  }
  const lastWorkoutTypeIcons = {
    [CardioOrResistance.Cardio]: <BurnIcon height={defaultScale(30)} width={defaultScale(30)} color={Theme.BLACK} />,
    [CardioOrResistance.Resistance]:  <BuildIcon height={defaultScale(30)} width={defaultScale(30)} color={Theme.BLACK} />,
    [CardioOrResistance.Balance]:  <BalanceIcon strokeWidth={2} height={defaultScale(30)} width={defaultScale(30)} color={Theme.BLACK} />,
  }
  const workoutType = weeklyWorkoutStats.lastWorkoutStats.workoutSettings.cardioOrResistance;
  return (
    <TouchableOpacity
      style={styles.mainTileContainer}
      onPress={() => { navigation.navigate('TrackingWorkoutStats') }}
    >
      <View style={styles.tile}>
        <TileHeader>{t('lastWorkout')}</TileHeader>
        <View>
          <View style={styles.lastWorkoutSettingsRow}>
            {lastWorkoutTypeIcons[workoutType]}
            <Text style={styles.lastWorkoutText}>{weeklyWorkoutStats.lastWorkoutStats.lastWorkoutDetails}</Text>
          </View>
          {lastWorkoutHasMetrics &&
            <View style={styles.lastWorkoutMetrics}>
              <View>
                <Text style={styles.lastEffortPointText}>{weeklyWorkoutStats.lastWorkoutStats.effortPoints}</Text>
                <Text style={styles.metricName}>{t('effortPoints')}</Text>
              </View>
              <View style={styles.metricContainer}>
                <Text style={styles.metricValue}>{weeklyWorkoutStats.lastWorkoutStats.calories}</Text>
                <Text style={styles.metricName}>{t('calories')}</Text>
              </View>
              <View style={styles.metricContainer}>
                <Text style={styles.metricValue}>{weeklyWorkoutStats.lastWorkoutStats.averageHeartRate}%</Text>
                <Text style={styles.metricName}>{t('heartRate')}</Text>
              </View>
            </View>
          }
        </View>
      </View>
      {!hasHeartRateMonitor && Platform.OS !== 'web' &&
        <NoHeartRateMonitorImageTile containerStyle={{ marginTop: 0 }} />
      }
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  mainTileContainer: {
    marginBottom: defaultScale(12),
  },
  tile: {
    backgroundColor: Theme.WHITE,
    paddingTop: defaultScale(20),
    paddingHorizontal: defaultScale(16),
  },
  lastWorkoutTileHeader: {
    ...Theme.textStyle.heading,
  },
  seeAll: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.PRIMARY,
    alignSelf: 'flex-end',
  },
  tileHeader: {
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
  },
  lastWorkoutSettingsRow: {
    borderColor: Theme.GREY_LIGHT,
    borderTopWidth: defaultScale(1),
    borderBottomWidth: defaultScale(1),
    marginTop: defaultScale(10),
    paddingTop: defaultScale(15),
    paddingBottom: defaultScale(15),
    flexDirection: 'row',
    alignItems: 'center',
  },
  lastWorkoutText: {
    paddingLeft: defaultScale(15),
    ...Theme.textStyle.bodyCopyReg,
    fontSize: scaledRatio(16, 0.5),
  },
  lastWorkoutMetrics: {
    marginTop: defaultScale(15),
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: defaultScale(24),
  },
  lastEffortPointText: {
    ...Theme.textStyle.heading,
  },
  metricName: {
    ...Theme.textStyle.small,
  },
  metricContainer: {
  },
  metricValue: {
    ...Theme.textStyle.heading,
  },
});

const mapStateToProps = (state: any) => {
  return {
    weeklyWorkoutStatsIsLoading: state.tracking.view.weeklyWorkoutStatsIsLoading,
    weeklyWorkoutStats: state.tracking.data.weeklyWorkoutStats,
    hasLastWorkout: state.tracking.data.hasLastWorkout,
    lastWorkoutHasMetrics: state.tracking.data.lastWorkoutHasMetrics,
  };
};

export const LastWorkoutTile =
  connect(mapStateToProps)(
    translate(['tracking'], { wait: true })(LastWorkoutTileComponent));
